/**
 * clearFilter - is a custom SVG Icon that displays when a filter is applied to a Grid column.
 */
import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const ClearFilter = createSvgIcon(
  <g fill="none" fillRule="evenodd" transform="translate(3.5, 3.5)">
    <g id="Mask" fill="#176DC2">
      <path d="m9.7023 7.7237h-6.703v2h9.483c-1.136-0.347-2.114-1.049-2.78-2" />
      <path d="m9.15 2.7237h-9.15v2h8.75c0-0.709 0.145-1.383 0.4-2" />
      <polygon points="6.9998 14.723 11 14.723 11 12.723 6.9998 12.723" />
      <path
        d={
          'm16.5 6.545-0.705 0.705-1.795-1.796-1.795 1.796-0.705-0.705 1.795-1.795-1.795-1.796 0.705-0.704 1.795 1.795 1.795-1.795 0.705 0.704-1.795' +
          ' 1.796 1.795 1.795zm-2.5-6.545c-2.619 0-4.75 2.131-4.75 4.75s2.131 4.75 4.75 4.75 4.75-2.131 4.75-4.75-2.131-4.75-4.75-4.75z'
        }
      />
    </g>
  </g>,
  'ClearFilter'
);
